<template>
    <dl class="warns">
        <dt><i class="jc-icon icon-prompt-warning"></i><span>{{title}}</span></dt>
        <dd v-for="(item, index) in list" :key="index">{{item}}</dd>
    </dl>
</template>

<script>
export default {
  name: 'jc-warns',
  props: {
    title: {
      type: String,
      default: '温馨提示：'
    },
    list: {
      type: Array,
      default () {
        return []
      }
    }
  }
}
</script>

<style lang="scss">
.warns {
    dt {
        i {
            font-size: 24px;
            margin-right: 8px;
            vertical-align: middle;
        }
        span {
            vertical-align: middle;
        }
    }
    dd {
        margin-left: 32px;
        margin-top: 6px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/warns/index.vue